/* @flow */

import { createReducer } from 'src/shared/core/util/reducerUtils';
import * as types from 'src/shared/domain/user/action/userActionTypes';

import type { State } from 'src/shared/core/type/reduxTypes';

/*
 |------------------------------------------------------------------------------
 | Initial state
 |------------------------------------------------------------------------------
 */

const initialState = {};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const markTopicKeywordsAsFetching = (state: State, { userId }: Object) => {
  const userState = state[userId] || {};

  return {
    ...state,
    [userId]: {
      ...userState,
      areTopicKeywordsFetching: true,
    },
  };
};

const unmarkTopicKeywordsAsFetching = (state: State, { userId }: Object) => {
  const userState = state[userId] || {};

  return {
    ...state,
    [userId]: {
      ...userState,
      areTopicKeywordsFetching: false,
    },
  };
};

const markInterestsAsFetching = (state: State, { userId }: Object) => {
  const userState = state[userId] || {};

  return {
    ...state,
    [userId]: {
      ...userState,
      areInterestsFetching: true,
    },
  };
};

const unmarkInterestsAsFetching = (state: State, { userId }: Object) => {
  const userState = state[userId] || {};

  return {
    ...state,
    [userId]: {
      ...userState,
      areInterestsFetching: false,
    },
  };
};

export default createReducer(initialState, {
  [types.SIMULATE_USER_TOPIC_KEYWORDS_REQUEST]: markTopicKeywordsAsFetching,
  [types.FETCH_USER_TOPIC_KEYWORDS_REQUEST]: markTopicKeywordsAsFetching,
  [types.FETCH_USER_TOPIC_KEYWORDS_SUCCESS]: unmarkTopicKeywordsAsFetching,
  [types.FETCH_USER_TOPIC_KEYWORDS_FAILURE]: unmarkTopicKeywordsAsFetching,
  [types.SIMULATE_USER_INTERESTS_REQUEST]: markInterestsAsFetching,
  [types.FETCH_USER_INTERESTS_REQUEST]: markInterestsAsFetching,
  [types.FETCH_USER_INTERESTS_SUCCESS]: unmarkInterestsAsFetching,
  [types.FETCH_USER_INTERESTS_FAILURE]: unmarkInterestsAsFetching,
});
